<template lang="pug">
  .boxMenu
    vm-icon(v-if="approved" type="flat" icon="checkmark-circle-2-outline" color="rgb(23, 201, 100)")
    vm-icon(v-else type="flat" icon="clock-outline" color="rgba(var(--gray),1)")
</template>

<script>
export default {
  name: 'iconRevission',
  props: {
    approved: {
      type: Boolean
    }
  }
}
</script>
<style lang="stylus" scoped>

</style>
